import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { BankStatementsOnlineBankingContent } from './bank-statements-online-banking-content';
import { useFetchStateDataIfNull, useQuery } from '../../util/hooks';

export const BankStatementsOnlineBankingPage = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <BankStatementsOnlineBankingContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
